(() => {
  const ADD_TO_CART_LABEL = 'AJOUTER AU PANIER';
  const BUTTON_SELECTOR = [
    '.rsvp-product-buy__button',
    '[data-azyra-capacity-reserve]',
    '[data-rsvp-story-reserve]',
    '.azyra-capacity-modal__reserve',
    '.rsvp-story-modal__product-button'
  ].join(',');

  let productPromise = null;

  function productJsonUrl() {
    const pathname = window.location.pathname.replace(/\/$/, '');
    return `${pathname}.js`;
  }

  async function getCurrentProduct() {
    if (!productPromise) {
      productPromise = fetch(productJsonUrl(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !Array.isArray(data.variants)) {
          throw new Error('Le produit ne peut pas être chargé.');
        }
        return data;
      });
    }

    return productPromise;
  }

  function preparePage(root = document) {
    root.querySelectorAll('.azyra-reservation-modal, [data-azyra-reservation-modal]').forEach((modal) => modal.remove());
    document.body.classList.remove('azyra-reservation-lock');

    root.querySelectorAll('.rsvp-product-buy__shipping-note').forEach((note) => note.remove());

    root.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      button.removeAttribute('data-azyra-reservation-open');
      button.type = 'button';
      button.textContent = ADD_TO_CART_LABEL;
    });
  }

  function closeProductPopups() {
    document.querySelectorAll('.azyra-capacity-modal.is-open, .rsvp-story-modal.is-open').forEach((modal) => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });

    document.body.classList.remove('azyra-capacity-lock', 'rsvp-story-lock');
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

    const cartTrigger = document.querySelector(
      '[aria-controls="CartDrawer"], [aria-controls="cart-drawer"], [data-cart-drawer-open], a[href="/cart"], a[href$="/cart"]'
    );

    if (cartTrigger) {
      window.setTimeout(() => cartTrigger.click(), 250);
      return;
    }

    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  }

  async function addCurrentProduct(button) {
    if (!button || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'AJOUT EN COURS…';

    try {
      const product = await getCurrentProduct();
      const variant = product.variants.find((item) => item.available) || product.variants[0];

      if (!variant || !variant.id) {
        throw new Error('Ce produit ne peut pas être ajouté au panier.');
      }

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: Number(variant.id), quantity: 1 }]
        })
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Impossible d’ajouter le produit au panier.');
      }

      closeProductPopups();
      openCartDrawer();
    } catch (error) {
      console.error('[AZYRA cart]', error);
      window.alert(error.message || 'Impossible d’ajouter le produit au panier.');
    } finally {
      button.disabled = false;
      button.textContent = originalLabel || ADD_TO_CART_LABEL;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addCurrentProduct(button);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => preparePage(), { once: true });
  } else {
    preparePage();
  }

  document.addEventListener('shopify:section:load', (event) => preparePage(event.target));
})();
